import TextImage from "../../../UI/TextImage/TextImage";
import mainImage from "../../../../assets/HomePage/BuildNetworkImg.png";

const BuildNetwork = (props) => {
  return (
    <TextImage
      imageThenText={false}
      header={"Flagship Access."}
      paragraph={`With the 100card, you will be able to claim special deals from our partners, access our private clubhouse (WIP), attend masterclasses, and get private mentorship.`}
      src={mainImage}
      alt={"Build Network"}
      maxWidth={{ maxWidth: "250px" }}
    />
  );
};

export default BuildNetwork;
